import { Path, Node } from "slate";
import { ContemberEditor } from "../index.js";
const hasParentOfType = (editor, nodeEntry, type, suchThat) => {
  const [, path] = nodeEntry;
  if (path.length === 1) {
    return false;
  }
  const parentPath = Path.parent(path);
  const parent = Node.get(editor, parentPath);
  return ContemberEditor.isElementType(parent, type, suchThat);
};
export {
  hasParentOfType
};
//# sourceMappingURL=hasParentOfType.js.map
